import { setObjectValue, Dep, Seq } from "../../../framework/Processes";
import { External } from "../../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../../framework/comp/Types";

let countArr = [1, 2, 5, 10, 20, 30];

export default {
    name: 'task_0_3',
	description: 'Заставка',
	title: 'Количество задач',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите, сколько задач будет предложено вам в первом раунде",
			options: [
                'Одна', 'Две', 'Пять', 'Десять', 'Двадцать'
			],
			correct: [1,2]
        };
	},
	isCompleted: () => true,
	postprocess: Dep(External(function(state) {
		const { history } = state.objects;
		const playerChoice = history[history.length - 1].playerAns;
		return Seq([setObjectValue("count", countArr[playerChoice]), setObjectValue("curcount", countArr[playerChoice]), setObjectValue("init", true)]);
	}, "Function", FunctionType("Object", "Process"))),
	messages() {
		return {
			onFinish: () => "Начинаем первый раунд!",
		};
	},
	
}